import { styled, type SxProps, type Theme } from "@mui/material/styles";

export const TOOLBAR_SX: SxProps<Theme> = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: 1.5,
};

export const ACTIONS_SX: SxProps<Theme> = { display: "flex", alignItems: "center", gap: 1.5 };

export const TAB_LABEL_SX: SxProps<Theme> = { display: "inline-flex", alignItems: "center", gap: 1 };

/** Red in every tab state, the selected fill included: the tab's own colour is not inherited. */
export const TAB_ERROR_SX: SxProps<Theme> = (theme) => ({ display: "inline-flex", color: theme.palette.error.main });

export const CONTENT_SX: SxProps<Theme> = (theme) => ({
  display: "flex",
  flex: 1,
  minHeight: 0,
  borderTop: 1,
  borderColor: theme.palette.divider,
});

export const SIDEBAR_SX: SxProps<Theme> = (theme) => ({
  display: "flex",
  flexDirection: "column",
  flexShrink: 0,
  width: 320,
  minHeight: 0,
  overflowY: "auto",
  py: 1.5,
  pr: 1.5,
  borderRight: 1,
  borderColor: theme.palette.divider,
});

export const PREVIEW_SX: SxProps<Theme> = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  flex: 1,
  minWidth: 0,
  minHeight: 0,
  gap: 1,
  pt: 1.5,
  pl: 1.5,
};

export const FIELDS_SX: SxProps<Theme> = { display: "flex", flexDirection: "column", gap: 1.5 };

export const FIELD_ROW_SX: SxProps<Theme> = { display: "flex", alignItems: "flex-end", gap: 1 };

export const GROW_SX: SxProps<Theme> = { flex: 1, minWidth: 0 };

export const FIXED_WIDTH_SX: SxProps<Theme> = { width: 96, flexShrink: 0 };

export const FIELD_GROUP_SX: SxProps<Theme> = { display: "flex", flexDirection: "column", gap: 0.75 };

export const FULL_WIDTH_SX: SxProps<Theme> = { width: "100%" };

export const PADDING_INPUTS_SX: SxProps<Theme> = {
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  gap: 1,
  flex: 1,
  minWidth: 0,
};

export const PADDING_ROW_SX: SxProps<Theme> = { display: "flex", alignItems: "flex-start", gap: 1 };

export const BANNER_FILE_SX: SxProps<Theme> = { display: "flex", alignItems: "center", gap: 1 };

export const BANNER_FILE_NAME_SX: SxProps<Theme> = {
  flex: 1,
  minWidth: 0,
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
};

export const SPECIFICATIONS_SX: SxProps<Theme> = { display: "flex", flexDirection: "column", gap: 1, m: 0 };

export const SPECIFICATION_TERM_SX: SxProps<Theme> = (theme) => ({
  ...theme.typography.body2,
  fontWeight: theme.typography.fontWeightBold,
  color: theme.palette.text.secondary,
});

export const SPECIFICATION_DETAIL_SX: SxProps<Theme> = (theme) => ({ ...theme.typography.body2, m: 0 });

export const ERROR_SX: SxProps<Theme> = (theme) => ({ p: 4, color: theme.palette.error.main });

/** Outlined, so White still shows against the field. */
export const ColorSwatch = styled("span", {
  shouldForwardProp: (prop) => prop !== "swatchColor",
})<{ swatchColor: string }>(({ theme, swatchColor }) => ({
  display: "block",
  width: 20,
  height: 20,
  borderRadius: 2,
  border: `1px solid ${theme.palette.divider}`,
  backgroundColor: swatchColor,
}));

export const ROTATE_90_SX: SxProps<Theme> = { display: "flex", transform: "rotate(90deg)" };

export const ROTATE_180_SX: SxProps<Theme> = { display: "flex", transform: "rotate(180deg)" };

export const ROTATE_270_SX: SxProps<Theme> = { display: "flex", transform: "rotate(270deg)" };
